module.exports = __webpack_public_path__ + "static/img/bzzx.8230f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bzzx.png
// module id = BdLl
// module chunks = 2